import { Stack, Typography } from '@mui/material'

import PointsAdjust from '@/components/PointsAdjust'

export function PointsBulkImport({
  points,
  handleUpdatePointsCard,
}: {
  points: number
  handleUpdatePointsCard: (points: number) => void
}) {
  return (
    <Stack
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        gap: '6px',
      }}
    >
      <Typography fontWeight="medium">Points</Typography>
      <PointsAdjust
        customWidth="30px"
        points={points}
        // @ts-ignore
        setPoints={handleUpdatePointsCard}
      />
    </Stack>
  )
}
